// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".voting-nominations-error-message__wrapper[data-v-13deee8c]{margin-top:32px}", ""]);
// Exports
module.exports = exports;
